<template>
  <v-card class="mt-4" outlined v-if="error == false">
    <v-card-title> Descuentos </v-card-title>
    <v-card-text>
      <v-container class="pa-0" v-if="userInfo != null">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model.number="userInfo.descuento_metalicos"
              @input="setProcessedDiscounts"
              label="Metálicos"
              type="number"
              min="0"
              max="100"
              step="0.1"
              suffix="%"
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model.number="userInfo.descuento_panel_ternium"
              @input="setProcessedDiscounts"
              label="Panel Ternium"
              type="number"
              min="0"
              max="100"
              step="0.1"
              suffix="%"
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model.number="userInfo.descuento_isocindu"
              @input="setProcessedDiscounts"
              label="Isocindu"
              type="number"
              min="0"
              max="100"
              step="0.1"
              suffix="%"
              dense
            />
          </v-col>
          <v-col cols="12" md="3" v-for="(d, i) in descuentos" :key="i.id">
            <v-text-field
              :label="d.subfamilia.nombre"
              v-model.number="d.valor"
              @input="setProcessedDiscounts"
              type="number"
              min="0"
              max="100"
              step="0.1"
              suffix="%"
              dense
            />
          </v-col>
        </v-row>
      </v-container>
      <v-container class="pa-0 text-center" v-else>
        <v-progress-circular class="d-block ma-auto" size="32" indeterminate />
        <h6 class="text-subtitle-2 mt-4">Obteniendo información</h6>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { httpPost } from "@/services/apiService";

export default {
  props: {
    userInfo: Object | null,
  },
  data() {
    return {
      error: false,
      descuentos: [],
    };
  },
  methods: {
    async getDiscountData(id) {
      const { data } = await httpPost("/clientes/client-discounts", {
        data: { id },
      }).catch((err) => {
        console.error("Could not obtain discounts. Hiding card...");
        this.error = true;
        return;
      });

      this.descuentos = data?.descuentos;
    },
    setProcessedDiscounts() {
      this.$store.commit("setProccessedDiscounts", this.descuentos);
    },
  },
  watch: {
    userInfo(newVal) {
      if (newVal == null) {
        return;
      }

      this.getDiscountData(newVal?.id);
    },
  },
};
</script>